import { render, staticRenderFns } from "./BuilderPageModules.vue?vue&type=template&id=5eab6366&scoped=true"
import script from "./BuilderPageModules.vue?vue&type=script&lang=ts"
export * from "./BuilderPageModules.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eab6366",
  null
  
)

export default component.exports